import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { blogApi } from "./blogApi";

export const useBlogPosts = (skip: number, limit: number, searchPhrase: string = "") => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.BLOG_POSTS(skip, limit, searchPhrase),
    queryFn: () => blogApi.fetchBlogPosts(skip, limit, searchPhrase),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.BLOG_POSTS(skip, limit, searchPhrase),
    });
  };

  const invalidateAll = () => {
    queryClient.invalidateQueries({
      predicate: (query) => query.queryKey[0] === "blogPosts",
    });
  };

  return {
    isLoading,
    isFetching,
    blogPosts: data?.data.data ?? [],
    total: data?.data.total ?? 0,
    invalidate,
    invalidateAll,
  };
};

export const useBlogPost = (blogPostId: string | number | undefined) => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.BLOG_POST_BY_ID(blogPostId!),
    queryFn: () => blogApi.fetchBlogPost(Number(blogPostId)),
    enabled: !!blogPostId,
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.BLOG_POST_BY_ID(blogPostId!),
    });
    // Also invalidate the list cache
    queryClient.invalidateQueries({
      predicate: (query) => query.queryKey[0] === "blogPosts",
    });
  };

  return {
    isLoading,
    isFetching,
    blogPost: data?.data,
    invalidate,
  };
};
